import { configureStore, createSlice } from '@reduxjs/toolkit'


let isLoggedIn = createSlice({
    name: 'isLoggedIn',
    initialState: localStorage.getItem('isLoggedIn') || false,
    reducers: {
        setIsLoggedIn: (state) => {
            return !state
        }
    }
})

let guitars = createSlice({
    name: 'guitars',
    initialState: [
        { id: 0, title: "fender American Ultra Jazzmaster", price: 3000000, updated: "2 mins ago" },
        { id: 1, title: "fender Player 2 Stratocaster", price: 4500000, updated: "3 mins ago" },
        { id: 2, title: "fender Vintera 2 '60s Stratocaster", price: 1200000, updated: "15 mins ago" },
        { id: 3, title: "fender Kurt Cobain Jaguar", price: 3700000, updated: "1 hours ago" },
        { id: 4, title: "fender Vintera 2 70's Competition Mustang", price: 2500000, updated: "1 hours ago" },
        { id: 5, title: "fender Limited Edition Player Plus Telecaster, Crimson Red Transparent", price: 4000000, updated: "3 hours ago" },
        { id: 6, title: "James Burton Telecaster", price: 1500000, updated: "3 hours ago" },
        { id: 7, title: "Buddy Guy Standard Stratocaster", price: 2000000, updated: "4 hours ago" },
        { id: 8, title: "Jeff Beck Stratocaster", price: 1800000, updated: "17 hours ago" },
        { id: 9, title: "Jim Root Stratocaster", price: 2200000, updated: "18 hours ago" },
        { id: 10, title: "Ben Gibbard Mustang", price: 3200000, updated: "3 days ago" },
        { id: 11, title: "Gold Foil Jazzmaster", price: 2700000, updated: "4 days ago" },
        { id: 12, title: "Jim Root Jazzmaster V4", price: 4100000, updated: "1 weeks ago" },
        { id: 13, title: "Aerodyne Special Telecaster", price: 3500000, updated: "1 weeks ago" },
        { id: 14, title: "J Mascis Telecaster", price: 2900000, updated: "2 weeks ago" },
        { id: 15, title: "Vintera 2 70's Telecaster Deluxe with Tremolo", price: 2400000, updated: "3 weeks ago" },
        { id: 16, title: "Vintera 2 50's Nocaster", price: 1400000, updated: "4 weeks ago" }
    ],
    reducers: {

    }
})

let cart = createSlice({
    name: 'cart',
    initialState: JSON.parse(localStorage.getItem('cart')) || [
        { id: 0, quantity: 1, checked: true },
        { id: 7, quantity: 1, checked: true },
    ],
    reducers: {
        addItem: (state, action) => {
            const id = action.payload;
            const existingItem = state.find(item => item.id === id);
            if (existingItem) {
                existingItem.quantity += 1;
            } else {
                state.push({ id, quantity: 1, checked: true });
            }
        },
        removeItem: (state, action) => {
            const id = action.payload;
            return state.filter(item => item.id !== id);
        },
        updateItem: (state, action) => {
            const { id, changes } = action.payload;
            const existingItem = state.find((item) => item.id === id);
            if (existingItem) {
                Object.assign(existingItem, changes);
            }
        },
    },
});

export let { setIsLoggedIn } = isLoggedIn.actions
export let { addItem, removeItem, updateItem } = cart.actions 

const store = configureStore({
    reducer: {
        isLoggedIn: isLoggedIn.reducer,
        guitars: guitars.reducer,
        cart: cart.reducer,
    },
});

// LocalStorage에 cart 상태 저장
store.subscribe(() => {
    localStorage.setItem('cart', JSON.stringify(store.getState().cart));
});

export default store;